<template>
  <div id="app" v-loading="!hasInit" element-loading-text="系统跳转中...">
    <el-container v-if="hasInit">
      <el-header style="border-bottom: 1px solid #ccc;">
        <myNav @changeOrg="changeOrg" @openHelp="openHelp" :orgList="orgList" :orgId="confirmOrg"></myNav>
      </el-header>
      <el-container class="mainContainer">
        <el-aside width="220px">
          <myMenu :orgId="confirmOrg" :active="activeMenu" />
        </el-aside>
        <el-main style="height: calc(100vh - 60px);overflow-y: auto;">
          <router-view />
        </el-main>
      </el-container>
    </el-container>

    <!--支付弹出框-->
    <el-dialog class="payContainer" :visible.sync="payDialogVisible" width="780px" center>
      <pay v-if="payDialogVisible" :fileType="payData.fileType" :reportId="payData.id"
        :reportType="payData.reportType" />
    </el-dialog>

    <!-- 企业选择弹出框--->

    <el-dialog :visible.sync="orgDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :show-close="false" title="机构选择" width="30%" custom-class="orgDialog" center>
      <template #title>
        <div class="orgTitle">

        </div>

      </template>

      <el-radio v-model="curOrg" :label="-1">个人用户</el-radio>
      <div style="clear:both;height:10px;"></div>
      <div v-for="item in orgList" :key="item.ADMIN_TYPE_INFO_ID">
        <el-radio v-model="curOrg" :label="item.ADMIN_TYPE_INFO_ID">{{ item.CUSTOMER_NAME }}</el-radio>
        <div style="clear:both;height:10px;"></div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary"
            @click="chooseOrg(0)">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;确定&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
          <div style="clear:both;height:10px;"></div>
          <el-checkbox v-model="rememberOrg">记住选择</el-checkbox>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>

import myMenu from './components/menu'
import myNav from './components/nav'
import pay from './components/pay'
export default {
  name: 'App',

  data () {
    return {
      hasInit: false,
      activeMenu: '/index',
      curLoginDialog: false,
      type: 'login',
      imgCaptcha: {},
      payDialogVisible: false,
      payData: {},
      fileType: '',
      reportType: '',
      accountForm: {
        account: '',
        password: '',
        imgCaptcha: '',
        agreeChecked: true
      },
      accountRules: {
        account: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
        ],
        imgCaptcha: [
          { required: true, message: '图片验证码不能为空', trigger: 'blur' }
        ]
      },
      regForm: {
        mobile: '',
        password: '',
        rePassword: '',
        agreeChecked: true,
        companyName: '',
        job: '',
        name: '',
        imageCaptcha: '',
        smsCaptcha: ''
      },
      regRules: {
        mobile: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '用户密码不能为空', trigger: 'blur' }
        ]
      },
      changeType (t) {
        this.type = t
      },
      orgList: [],
      curOrg: '',
      confirmOrg: '',
      orgDialog: false,
      showUserOption: false,
      token: '',
      rememberOrg: false

    }
  },
  components: {
    myMenu, myNav, pay
  },
  mounted: function () {
    this.curOrg = parseInt(localStorage.getItem('selectedOrgId') || '-1')
    this.rememberOrg = localStorage.getItem('rememberOrg') === 'true'

    let token = this.$route.query.token
    let path = this.$route.query.path || ''
    let code = this.$route.query.code

    this.activeMenu = path
    let _this = this

    if (token && code) { // csmar 等代理商登录
      _this.axios.post('/api/web/proxy/login', _this.$route.query).then(resp => {
        _this.hasInit = true
        _this.$router.push({ 'path': '/' })
        _this.$store.commit('toFreshUserPrice')
        _this.$store.commit('refreshUserInfo')
        _this.getOrganization()
      })
    } else {
      this.getOrganization()
    }
  },
  methods: {
    openHelp () {
      console.log('打开帮助中心')
      this.activeMenu = '/help'
      this.$router.push({ 'path': '/help' })
    },
    changeOrg () {
      this.orgDialog = true
    },
    chooseOrg (val) {
      let _this = this
      if (!val) {
        val = this.curOrg
      } else {
        this.curOrg = val
      }
      this.axios.get(`/api/web/csmarUser/selectOrg?admin_type_info_id=${val}`).then(resp => {
        _this.$store.commit('changeOrg', val)
        sessionStorage.setItem('localOrg:' + _this.token, val)
        _this.orgDialog = false
        _this.confirmOrg = _this.curOrg
      })
    },
    getOrganization () {
      let _this = this
      this.hasInit = true
      this.axios.get('/api/web/csmar/csmarToken').then(resp2 => {
        _this.token = resp2.data
        _this.axios.get('/api/web/csmarUser/queryUserOrganizaionList').then(resp => {
          _this.orgList = resp.data && resp.data.Data

          if (!_this.orgList || _this.orgList.length === 0) {
            _this.curOrg = -1
            _this.confirmOrg = _this.curOrg
            return
          }
          let localOrg = sessionStorage.getItem('localOrg:' + _this.token)

          if (localOrg) {
            this.chooseOrg(parseInt(localOrg))
            return
          }

          let remmembId = localStorage.getItem('selectedOrgId')

          if (localStorage.getItem('rememberOrg') === 'true' && remmembId) {
            _this.curOrg = parseInt(remmembId)
            _this.chooseOrg(parseInt(remmembId))
            return
          }

          if (_this.orgList.length > 0) {
            _this.curOrg = _this.curOrg || _this.orgList[0].ADMIN_TYPE_INFO_ID
            _this.orgDialog = true
          } else {
            _this.curOrg = -1
            _this.confirmOrg = _this.curOrg
          }
        })
      })
    },
    toReg () {
      this.axios.post('/api/web/auth/regUser', this.regForm).then(resp => {
        localStorage.setItem('userinfo', JSON.stringify(resp.data))
        if (window.parent) {
          window.open(window.parent.location.href, '_top')
        }
        window.location.reload()
      })
    },
    loginByMobile () {
      let _this = this
      this.$refs['accoutRuleForm'].validate((valid) => {
        if (valid) {
          _this.accountForm.imgCaptchaKey = _this.imgCaptcha.key
          this.axios.post('/api/web/csmar/loginByAccount', _this.accountForm).then(resp => {
            localStorage.setItem('userinfo', JSON.stringify(resp.data))
            if (window.parent) {
              window.open(window.parent.location.href, '_top')
            }
            window.location.reload()
          })
        } else {
          return false
        }
      })
    },
    checkMobile () {
      if (this.regForm.mobile) {
        this.axios.post('/api/web/auth/checkMobile', { 'mobile': this.regForm.mobile })
      }
    },
    toSendSms () {
      this.axios.post('/api/web/auth/sendSmsCaptcha', { 'mobile': this.regForm.mobile, 'key': this.imgCaptcha.key, 'imgCaptcha': this.regForm.imageCaptcha })
    },
    toGetImgCaptcha () {
      let _this = this
      this.axios.get('/api/web/auth/captchaImg?' + Math.random()).then(resp => {
        _this.imgCaptcha = resp.data
      })
    }

  },
  computed: {
    payResult: function () {
      return this.$store.state.payResult
    },
    loginDialog () {
      return this.$store.state.loginDialogVisible
    },
    payDialog () {
      return this.$store.state.payDialogVisible
    }
  },
  watch: {
    payResult: function () {
      this.payDialogVisible = false
    },
    loginDialog: function () {
      if (this.loginDialog) {
        this.curLoginDialog = true
        this.toGetImgCaptcha()
      }
    },
    payDialog: function () {
      this.payData = this.$store.state.payData
      this.payData = this.$store.state.payData
      let tempOrgId = localStorage.getItem('selectedOrgId')
      if (tempOrgId && tempOrgId > 0) {
        this.$alert('当前企业帐号内已无下载次数，请切换至其他账户或联系客服进行续费。', {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      } else {
        this.payDialogVisible = true
      }
    },
    rememberOrg: function () {
      localStorage.setItem('rememberOrg', this.rememberOrg)
    },
    curOrg: function () {
      localStorage.setItem('selectedOrgId', this.curOrg)
    }
  }

}
</script>
<style lang="less">
@import "./assets/css/index.less";

.imgCaptchaContainer .el-input-group__append {
  background-color: white;
}

.orgDialog {
  .el-dialog__body {
    padding: 44px 34px 10px 44px !important;
    font-size: 20px;

    .el-radio__label {
      padding-left: 10px !important;
      font-size: 16px;
    }

  }

  border-radius: 20px !important;
  overflow: hidden;

  width: 400px !important;

  .el-dialog__header {
    padding: 0px !important;

    .orgTitle {

      width: 400px;
      height: 133px;
      background-image: url('./assets/imgs/org_dialog_bg.png');
      background-size: 100%;
    }
  }
}
</style>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  min-height: 100vh;
}

html,
body {
  width: 100%;
  min-height: 100%;
  margin: 0px;
  padding: 0px;
  min-width: 1300px;
}

.el-header .el-dropdown {
  color: white;
}

.el-aside .el-menu-item:hover {
  color: #666666;
  background-color: #e8eaed;
}

.el-main {
  background-color: #f5f7fa;
}

.mainContainer {
  min-height: calc(100vh - 60px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue